import React from 'react';

interface PhoneMockupProps {
  children: React.ReactNode;
  gradient?: string;
}

export const PhoneMockup = React.memo<PhoneMockupProps>(({ children, gradient = 'from-violet-200 via-pink-100 to-white' }) => (
  <div className={`relative flex items-center justify-center w-full py-10 rounded-3xl bg-gradient-to-br ${gradient}`}>
    <div className="relative" style={{ width: 280, height: 560 }}>
      <div className="absolute inset-0 rounded-[44px] bg-black shadow-2xl shadow-black/30" />
      <div className="absolute inset-[6px] rounded-[40px] bg-black" />
      <div className="absolute inset-[10px] rounded-[36px] bg-white overflow-hidden">
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-6 bg-black rounded-full z-20" />
        <div className="pt-10 h-full overflow-hidden">{children}</div>
      </div>
      <div className="absolute -left-[3px] top-24 w-[3px] h-12 bg-gray-800 rounded-l" />
      <div className="absolute -left-[3px] top-40 w-[3px] h-20 bg-gray-800 rounded-l" />
      <div className="absolute -right-[3px] top-32 w-[3px] h-16 bg-gray-800 rounded-r" />
    </div>
  </div>
));
PhoneMockup.displayName = 'PhoneMockup';
